export const calculateTotal = (items, types) => 
    items.reduce((total, item) => types.includes(item.type) ? total + item.amount : total, 0);
